<div *ngIf="isAssistantEnabled()">
    <div *ngIf="activeAssistantType == assistantType.CUSTOMER">
        <client-portal-routemagic-assistant></client-portal-routemagic-assistant>
    </div>
    <div *ngIf="activeAssistantType == assistantType.AGENT">
        <agent-ccp-widget></agent-ccp-widget>
    </div>
    <!-- Other assistant type widgets can be added here -->
</div>
